import axios from "../../../../../axios";
import React, { useEffect, useState } from "react";
import "./channelRequest.css";
import moment from "moment";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import axios1 from "axios";
import { IP } from "../../../../../internalServer";
import assets from "../../../../../assets/assets";
import { toast } from "react-toastify";

const ChannelRequest = ({
  requestPost,
  setPostRequestCount,
  setRejectedPostCount,
  setPostStatusChanged,
  postStatusChanged,
  setInProgress,
  setRequestList,
  setFilter,
  filter,
  setIsPostCreated,
  setIsPostDeclined,
  getCommuntiy,
}) => {
  const [currentSlide, setCurrentSlide] = useState(1);
  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  const handleSlideChange = (current) => {
    setCurrentSlide(current + 1);
  };
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    afterChange: handleSlideChange,
    arrows: true,
  };
  const handelPostStatus = async (e) => {
    setInProgress(true);
    try {
      const status = e.target.value;

      const res = await axios.put(
        `/api/v1/community/${requestPost?.community_id?.id}/post/status/${requestPost?.id}`,
        {
          user_id: teacher_id,
          status,
        }
      );

      if (res) {
        // Remove the accepted/rejected post from current list immediately
        setRequestList((prev) =>
          prev.filter((item) => item.id !== requestPost.id)
        );

        toast.success(res.data.message);

        // Update counters
        if (status === "active") {
          setPostRequestCount((prev) => prev + 1);
          setIsPostCreated(true);
        } else if (status === "rejected") {
          setRejectedPostCount((prev) => prev + 1);
          setIsPostDeclined(true);
        }

        // Still refresh community counts or other data
        getCommuntiy();
      }
    } catch (error) {
      console.error(error);
    } finally {
      setInProgress(false);
    }
  };

  const timeHelper = (a) => {
    const dateObj = new Date(a);
    // Adding 5 hours and 30 minutes to the date
    dateObj.setUTCHours(dateObj.getUTCHours() + 5);
    dateObj.setUTCMinutes(dateObj.getUTCMinutes() + 30);

    const day = dateObj.getUTCDate();
    const month = dateObj.getUTCMonth() + 1;
    const year = dateObj.getUTCFullYear();
    const hours = dateObj.getUTCHours();
    const minutes = dateObj.getUTCMinutes();
    const seconds = dateObj.getUTCSeconds();

    const outputDateString = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return outputDateString;
  };

  console.log("requestPost", requestPost);

  return requestPost ? (
    <>
      {/* <div className="allPost_container"> */}

      <div className="col-md-12 p-0  request_channel_name_box">
        <div
          className="post_img_container w-100 mt-4 rounded-4"
          style={{ backgroundColor: "white" }}
        >
          <div
            className=" w-100 d-flex gap-2 flex-row "
            style={{ padding: "5px 10px" }}
          >
            {/* image */}
            <div className="gap-2 mt-1 mb-3 d-flex ">
              {requestPost?.user_id?.user_type === "Teacher" ? (
                <img
                  src={
                    requestPost?.user_id?.profile_picture
                      ? IP +
                        requestPost?.user_id?.profile_picture.replace(/^\./, "")
                      : requestPost?.user_id?.gender === "M"
                      ? "/images/Teacher_Male.jpg"
                      : requestPost?.user_id?.gender === "F"
                      ? "/images/Teacher_Female.png"
                      : "/images/default-profile.png"
                  }
                  alt="icon"
                  className="profilePicImg"
                  style={{ width: "40px", height: "40px", borderRadius: "50%" }}
                  onError={(e) => {
                    // This function will run if the image fails to load
                    if (requestPost?.user_id?.gender === "M") {
                      e.target.src = "/images/Teacher_Male.jpg";
                    } else if (requestPost?.user_id?.gender === "F") {
                      e.target.src = "/images/Teacher_Female.png";
                    } else {
                      e.target.src = "/images/default-profile.png";
                    }
                  }}
                />
              ) : (
                <img
                  src={
                    requestPost?.user_id?.profile_picture
                      ? IP +
                        requestPost?.user_id?.profile_picture.replace(/^\./, "")
                      : requestPost?.user_id?.gender === "M"
                      ? requestPost?.user_id?.avatar_profile
                        ? "/images/Boys/" +
                          requestPost?.user_id?.avatar_profile +
                          ".webp"
                        : "/images/Student_boy_pic.png"
                      : requestPost?.user_id?.gender === "F"
                      ? requestPost?.user_id?.avatar_profile
                        ? "/images/Girls/" +
                          requestPost?.user_id?.avatar_profile +
                          ".webp"
                        : "/images/Student_girl_pic.png"
                      : "/images/default image.png"
                  }
                  alt="icon"
                  className="prifilePicImg"
                  key={requestPost?.user_id?.avatar_profile}
                  style={{ width: "40px", height: "40px", borderRadius: "50%" }}
                  onError={(e) => {
                    if (requestPost?.user_id?.gender === "M") {
                      // console.log("insie if")
                      e.target.src = requestPost?.user_id?.avatar_profile
                        ? "/images/Boys/" +
                          requestPost?.user_id?.avatar_profile +
                          ".webp"
                        : "/images/Student_boy_pic.png";
                    } else if (requestPost?.user_id?.gender === "F") {
                      e.target.src = requestPost?.user_id?.avatar_profile
                        ? "/images/Girls/" +
                          requestPost?.user_id?.avatar_profile +
                          ".webp"
                        : "/images/Student_girl_pic.png";
                    } else {
                      e.target.src = "/images/default image.png";
                    }
                  }}
                />
              )}
            </div>

            <div
              className="p-2 rounded-3 w-100"
              style={{ border: "2px solid #E5E5E5", overflow: "hidden" }}
            >
              <div className="aaa">
                <div className=" d-flex justify-content-between px-2">
                  <div>
                    <span className="request_channel_name">
                      {requestPost?.user_id?.name}
                      &nbsp;
                      {requestPost?.user_id?.standard?.name} -
                      {requestPost?.user_id?.section?.name}
                    </span>

                    {requestPost?.tags.length > 0 ? (
                      <span className="related_postName mx-1  px-2 py-1">
                        {requestPost?.tags}
                      </span>
                    ) : null}
                    {/* <span className="related_postName mx-1  px-2 py-1">
                      {requestPost?.tags}
                    </span> */}
                  </div>
                  {/* <img src="/images/three dot hr.svg" /> */}
                  {requestPost.status === "pending" && (
                    <div className="under_review">Under Review</div>
                  )}
                  {requestPost.status === "rejected" && (
                    <div className="rejected">Rejected</div>
                  )}
                </div>

                <div className=" request_created_by px-2">
                  {requestPost?.community_id?.community_name}
                </div>
              </div>
              <small className="text-muted px-2">
                {moment(timeHelper(requestPost?.created_at)).calendar({
                  sameDay: "[Today] h:mm a",
                  lastDay: "[Yesterday] h:mm a",
                  lastWeek: "DD MMM YYYY h:mm a",
                  sameElse: "DD MMM YYYY h:mm a",
                })}
              </small>
              <p
                style={{
                  wordBreak: "break-all",
                  overflowWrap: "break-word",
                }}
                className="mt-2 view_post_descriptiont_text text-justify px-2"
              >
                {requestPost?.description}
              </p>

              {requestPost?.post_image?.length > 0 && (
                <div
                  style={{ width: "820px" }}
                  className=" col-12 p-0 request_post_image_box mb-5"
                >
                  <div className="slider_container">
                    <Slider {...settings}>
                      {requestPost?.post_image?.length > 0 &&
                        requestPost?.post_image?.map((item) => (
                          <img
                            src={`${IP + item}`}
                            className="request_post_image"
                            alt=""
                            onError={(e) => {
                              e.target.src = "/images/no-image5.png";
                            }}
                          />
                        ))}
                    </Slider>
                    {requestPost?.post_image?.length > 1 && (
                      <span className="post_image_count d-flex align-items-center justify-content-center">
                        {currentSlide}/{requestPost?.post_image?.length}
                      </span>
                    )}
                  </div>
                </div>
              )}

              {requestPost.status === "pending" && (
                <div className="accept_denie mt-4 mb-3 d-flex justify-content-center gap-sm-4 gap-3 flex-wrap ">
                  <button
                    value="active"
                    className="btn btn-danger col-sm-5  request_accept_btn"
                    onClick={(e) => handelPostStatus(e)}
                  >
                    Accept
                  </button>
                  <button
                    value="rejected"
                    className="btn btn-danger col-sm-5  request_decline_btn"
                    onClick={(e) => handelPostStatus(e)}
                  >
                    Decline
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* </div> */}
    </>
  ) : (
    <></>
  );
};

export default ChannelRequest;
